import React from 'react';
import './PolicyPage.scss';
import HeaderPolicy from '../../components/Header/HeaderPolicy';
import LayoutPolicy from '../../components/Layout/LayoutPolicy';

function SalusTermPage() {
    const titleText = "살루스케어 통합서비스 이용약관";

    return (
        <div className="policy" id="wrap">
            {/* header */}
            <HeaderPolicy title={titleText} />

            {/* contents, footer */}
            <LayoutPolicy>
                <div className="contents-new-agree__maintitle mt-0">
                    <span>
                        제 1 장 환영합니다!
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 1 조 (목적)
                    </span>
                </div>

                <div className="contents-new-agree__text">
                    <span>
                        주식회사 살루스케어(이하 ‘회사’)가 제공하는 서비스를 이용해 주셔서 감사합니다. 회사는 여러분이 회사가 제공하는 다양한 인터넷과 모바일 서비스(비타포트 서비스, 헬스케어 여기로 서비스 등을 의미하며, 이하 해당 서비스들을 모두 합하여 “통합서비스” 또는 “서비스”라 함)를 보다 편리하게 이용할 수 있도록 ‘살루스케어 통합서비스 이용약관’(이하 ‘본 약관’)을 마련하였습니다. 본 약관은 통합서비스를 이용하는 여러분과 회사 간의 권리, 의무 및 책임사항, 이용조건 및 절차 등 기본적인 사항을 규정하므로, 주의 깊게 읽어 주시기 바랍니다.
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 2 조 (정의)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>살루스케어 통합서비스(이하”서비스”): 회사가 운영하는 비타포트(VITAPORT) 및 헬스케어 여기로(HELLO) 서비스를 포함한 모든 온라인 및 모바일 서비스의 총칭</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>비타포트(VITAPORT):건강검진결과 기반 맞춤형 건강관리 플랫폼 및 커머스</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>헬스케어 여기로(HELLO):건강 모니터링 및 건강관리 프로그램 제공 서비스</span>
                    </div>
                    
                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">4. </span>
                        <span>회원: 본 약관에 따라 회사와 서비스 이용 계약을 체결하고 서비스를 이용하는 개인 또는 법인</span>
                    </div>
                    
                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">5. </span>
                        <span>살루스케어 계정: 회사가 제공하는 통합 인증 시스템을 이용하여 하나의 계정으로 서비스에 로그인 및 이용할 수 있도록 제공되는 계정</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>여러분은 본 약관에 동의함으로써 통합서비스에 가입하여 서비스를 이용할 수 있습니다. 통합서비스는 “살루스케어 계정”을 통해 제공되는 다양한 서비스(비타포트, 헬스케어 여기로 등을 포함하고 있습니다.) 단 이에 한정되지 않고 추가되는 서비스는 운영정책을 통해 고지될 수 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 3 조 (약관의 효력 및 변경)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>본 약관은 개별서비스 화면에서 게시되며, 이에 동의한 모든 회원에게 효력이 발생합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 관련 법령을 준수하는 범위 내에서 본 약관을 변경할 수 있으며, 변경 시 시행일자 15일 전부터 공지합니다. 단, 회원에게 불리한 변경의 경우 30일 전부터 개별 통지(이메일, 서비스 내 알림, 문자 등)합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>본조 제2항에 따라 개별통지하는 경우 ‘개정 약관 적용일까지 거부 의사를 표시하지 않을 경우 약관 개정에 동의한 것으로 본다’는 내용을 명확히 안내합니다. 회원이 개정 약관 적용일까지 명시적으로 거부 의사를 표시하지 않은 경우, 회원은 개정 약관에 동의한 것으로 간주됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>변경된 약관에 동의하지 않는 경우 회원은 개별 서비스에 접속해서 계약 해지를 선택할 수 있으며, 이는 통합서비스 해지가 아니라 서비스 해지를 희망하는 개별 서비스를 의미하며, 회원이 희망할 경우 통합서비스 전체를 해지할 수도 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 4 조 (약관 외 준칙)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>본 약관에 규정되지 않은 사항은 관련 법령, “살루스케어 계정 약관” 및 통합서비스 운영정책(비타포트 운영정책, 헬스케어 여기로 운영정책 등)에 따릅니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>개별 서비스의 운영정책과 본 약관이 충돌할 경우 본 약관이 우선 적용됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>운영정책은 개별 서비스 운영 및 기능에 대한 세부사항을 규정하며, 회원의 권리, 의무에 영향을 미치는 내용(결제, 개인정보 보호 등)은 본 약관을 따릅니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>개별 서비스에서 사용하는 용어의 정의는 개별 서비스의 운영정책을 통해 확인할 수 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__maintitle">
                    <span>
                        제 2 장 통합서비스 이용계약
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 5 조 (계약의 성립)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>통합서비스 이용을 위해 살루스케어 계정이 필요하며, 계정이 없는 경우 먼저 계정을 생성해야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>이용계약은 회원이 본 약관과 “살루스케어 계정 약관”에 동의하고, 회사가 가입 신청을 승인함으로써 성립합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 6 조 (회원의 권리 및 의무)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회원은 본 약관, “살루스케어 계정 약관”, 및 개별 서비스의 운영정책을 준수해야 하며, 타인의 권리를 침해하거나 불법적인 활동을 해서는 안 됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회원은 계정 정보 및 개인정보 보호를 위해 주의해야 하며, 이를 제 3자에게 양도하거나 공유해서는 안 됩니다.</span>
                    </div>
                    
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>회원이 서비스 이용 중 본 약관 제 6조 4항, 제 7조 1항을 위한하는 행위를 한 경우, 회사는 서비스 이용 제한 및 법적 조치를 취할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>회원은 다음 각호의 행위를 하여서는 안 됩니다.</span>
                    </div>
                    
                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>회원가입신청 또는 변경 시 허위내용의 등록</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>타인의 정보 도용</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>“회사”가 게시한 정보의 변경</span>
                    </div>
                    
                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">4. </span>
                        <span>“회사”가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</span>
                    </div>
                    
                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">5. </span>
                        <span>“회사”와 기타 제3자의 저작권 등 지적재산권에 대한 침해</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">6. </span>
                        <span>“회사” 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">7. </span>
                        <span>외설 또는 폭력적인 메시지, 화상, 음성, 기타 선량한 풍속 및 사회질서에 반하는 정보를 “서비스”에 공개 또는 게시하는 행위</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">8. </span>
                        <span>회사의 동의 없이 영리를 목적으로 “서비스”를 사용하는 행위</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">9. </span>
                        <span>기타 불법적이거나 부당한 행위</span>
                    </div>
                    
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 7 조 (통합서비스 이용 제한 및 계약 해지)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 다음의 경우 가입을 거부하거나 제한할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>타인의 명의를 도용한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>서비스 제공에 기술적, 운영적 장애가 발생하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>14세 미만 회원이 법정대리인 동의 없이 가입하려는 경우</span>
                    </div>
                    
                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">4. </span>
                        <span>기타 법령 및 운영정책 위반 사례</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 서비스 운영정책에 따라 경고, 일시 정지, 영구 정지 등의 단계를 적용할 수 있으며, 회원은 고객센터를 통해 이의 신청할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>위반 사실이 확인될 경우 회사는 계정 삭제 또는 서비스 이용을 제한할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>고객은 개별 서비스(비타포트, 헬스케어 여기로)를 각각 해지할 수 있으며, 개별 서비스 해지는 해당 서비스의 데이터 삭제 및 이용 종료를 의미합니다. 단, 통합서비스(살루스케어 계정)를 해지할 경우 개별 서비스 이용이 중단됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>비타포트(VITAPORT)</span>
                    </div>







                    
                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>“회원”은 언제든지 서비스 내 정보 관리 메뉴 등을 통하여 이용계약의 해지 신청을 할 수 있으며, “회사”는 관련법령 및 회사 정책 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">II. </span>
                        <span>“회원”이 이용계약을 해지할 경우, “회사”가 수집한 “회원”의 개인정보는 관련법령 및 개인정보처리방침에 따라 처리됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">III. </span>
                        <span>“회원”이 다음 각 호의 사유에 해당하는 경우, "회사"는 회원자격을 제한 및 정지하거나 “강제탈퇴회원”으로 처리할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">1. </span>
                        <span>다른 회원의 서비스 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">2. </span>
                        <span>"회사"를 이용하여 법령 또는 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">3. </span>
                        <span>동일한 “회원”이 2개 이상의 “아이디”를 생성하여 “서비스”를 이용하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">4. </span>
                        <span>서비스 내 이벤트 등에 부적절한 방법을 이용하여 참여하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">5. </span>
                        <span>기타 서비스 운영 정책에 위반하여 서비스를 이용하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">IV. </span>
                        <span>“회원”이 이용계약을 해지하거나, “회사”가 본 조 4항에 따라 “강제탈퇴회원” 처리할 경우, 무상으로 제공된 쿠폰과 포인트는 삭제되고 사용할 수 없습니다. 또한 삭제된 쿠폰과 포인트는 회원이 재가입을 하더라도 복구되지 않습니다. 단, 유상으로 구매한 포인트 및 쿠폰이 있을 경우는 환급처리가 이루어져야 하며, 환급처리가 되지 않는 경우 탈퇴 및 이용계약 해지가 이루어지지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth dash">
                        <span className="dash">2. </span>
                        <span>헬스케어 여기로(HELLO)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>회원은 회원정보수정을 통하여 회사에 언제든지 탈퇴를 요청할 수 있으며, 회사는 즉시 회원탈퇴를 처리한다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">II. </span>
                        <span>회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 상실 시킬 수 있다.</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="number">1. </span>
                        <span>회원 관련 정보에 허위 내용을 등록한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="number">2. </span>
                        <span>다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 질서를 위협하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="number">3. </span>
                        <span>회사 내에서 검증되지 않은 허위정보 및 기타 허락되지 않은 판매행위를 하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="number">4. </span>
                        <span>회사의 서비스 또는 공간을 이용하여 의료법상 금지된 진료행위를 하거나, 관련 법령에서 허용되지 않은 의료 광고, 홍보를 하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="number">5. </span>
                        <span>회사 내에 제공되는 정보를 변경하는 등 홈페이지 운영을 방해한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="number">6. </span>
                        <span>회사를 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="number">7. </span>
                        <span>본 약관을 위반한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering four-depth">
                        <span className="number">8. </span>
                        <span>기타 회원으로서의 자격을 지속시키는 것이 부적절하다고 판단되는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">III. </span>
                        <span>회원이 소속된 사업장의 소속 자격을 상실하더라도 회원이 탈퇴 의사를 밝히지 않는 한 회원 자격을 유지할 수 있으며, 기존에 이용한 검진결과 등을 포함한 서비스를 지속 이용 가능하다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">IV. </span>
                        <span> “회원”이 이용계약을 해지하거나, “회사”가 본 조에 따라 “강제탈퇴회원” 처리할 경우, 무상으로 제공된 쿠폰과 포인트는 삭제되고 사용할 수 없습니다. 또한 삭제된 쿠폰과 포인트는 회원이 재가입을 하더라도 복구되지 않습니다. 단, 유상으로 구매한 포인트 및 쿠폰이 있을 경우는 환급처리가 이루어져야 하며, 환급처리가 되지 않는 경우 탈퇴 및 이용계약 해지가 이루어지지 않습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__maintitle">
                    <span>
                        제 3 장 통합서비스 제공 및 운영
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 8 조 (서비스 제공범위 및 운영정책)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 회원에게 건강관리, 데이터 분석, 맞춤형 서비스 추천 등의 기능을 제공하며, 서비스의 구체적인 내용 및 범위는 “비타포트 운영정책”, “헬스케어 여기로 운영정책에서 정합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>서비스 제공 시간은 365일 24시간을 원칙으로 하며, 유지보수 등의 사유로 일부 기능이 제한될 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>회원은 통합서비스의 약관동의를 통해 개별 서비스(비타포트, 헬스케어 여기로 등)를 자유롭게 이용할 수 있으며, 일부 서비스 이용 시 추가 동의가 필요할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>회사는 서비스 관련 공지, 광고 등을 제공할 수 있으며, 광고성 정보는 사전 동의한 경우에만 전송됩니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 9 조 서비스 변경 및 중단
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 살루스케어 통합서비스를 365일, 24시간 쉬지 않고 제공하기 위하여 최선의 노력을 다합니다. 다만, 아래 각 호의 경우 살루스케어 통합 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>살루스케어 통합 서비스용 설비의 유지·보수 등을 위한 정기 또는 임시 점검의 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">2. </span>
                        <span>정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 살루스케어 통합서비스 이용에 지장이 있는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">3. </span>
                        <span>관계사와의 계약 종료, 정부의 명령/규제, 서비스/회원 정책 변경 등 회사의 제반 사정으로 살루스케어 통합 서비스를 유지할 수 없는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">4. </span>
                        <span>기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>전항에 의한 살루스케어 통합 서비스 중단의 경우에는 미리 “살루스케어 개정 약관 제12조 이용 계약의 해지” 에서 정한 방법으로 여러분에게 통지 내지 공지하겠습니다. 이 때 원만한 서비스 및 정책 변경 등을 위하여 서비스 이용 시 재로그인 또는 추가적인 동의 절차 등이 필요할 수 있습니다. 다만, 회사로서도 예측할 수 없거나 통제할 수 없는 사유(회사의 과실이 없는 디스크 내지 서버 장애, 시스템 다운 등)로 서비스가 중단된 경우에는 사전 통지 내지 공지를 할 수 없습니다. 이러한 경우에도 회사가 상황을 파악하는 즉시 최대한 빠른 시일 내에 서비스를 복구하도록 노력하되, 2시간 이상 복구가 지연될 시 살루스케어에서 제공하는 서비스의 공지사항 및 FAQ 등에 게시하여 알려 드리겠습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>회사는 서비스 종료 또는 주요 기능 변경이 발생할 경우, 회원이 불이익을 받지 않도록 30일 전 공지하며, 관련 데이터 백업을 지원할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>유료 서비스 회원은 서비스 종료 시 환불 또는 보상절차가 본 약관 및 개별 서비스 운영정책에 따라 적용될 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 10 조 (게시물의 관리)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회원의 게시물이 법령을 위반하거나 타인의 권리를 침해하는 경우, 회사는 관련 법령 및 정책에 따라 조치를 취할 수 있으며, 회원은 이에 대해 이의를 제기할 수 있으며 이를 통해 게시물 시정 요청을 받을 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회원이 게시한 콘텐츠의 저작권은 해당 회원에게 있으며, 회사는 서비스 운영 및 개선을 위한 범위 내에서 이를 사용할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>탈퇴 시 회원이 작성한 게시물은 삭제되지 않으며, 회원은 탈퇴 전에 직접 삭제해야 합니다. 단, 게시물 내용이 개인 정보와 관련될 경우, 개인정보 보호를 위해 조치가 취해질 수 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__maintitle">
                    <span>
                        제 4 장 쇼핑, 결제 및 환불 정책
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 11 조 (상품 판매 및 구매 프로세스)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>비타포트가 "회원"에게 제공하는 쇼핑 서비스는 다음 각 호의 내용과 같습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number_ring">1. </span>
                        <span>전자상거래 서비스: "회사"가 "서비스" 내에서 "상품 등"의 판매에 관한 정보를 제공하고 “회원”의 청약을 받아 “상품 등”을 판매하는 서비스 및 관련 부가서비스를 말합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number_ring">I. </span>
                        <span>상품 구매 및 맞춤 추천 등 관련 지원 서비스</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number_ring">II. </span>
                        <span>계약체결, 제3자를 통한 결제 지원 및 결제대금 보호 서비스</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number_ring">III. </span>
                        <span>상품검색정보 서비스</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number_ring">IV. </span>
                        <span>기타 전자상거래 관련 서비스(통신판매중개서비스 포함)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number_ring">V. </span>
                        <span>광고 및 프로모션 서비스</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number_ring">2. </span>
                        <span>기타 서비스: 구매후기 등 기타 정보 제공 서비스, 회사가 직접 또는 제휴사와 공동으로 제공하는 이벤트 서비스를 말합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>“회원”은 비타포트 내 "상품 등 "을 구매하기 전에 반드시 살루스케어가 비타포트 서비스 내에 작성한 "상품 등"의 상세 내용과 거래의 조건을 정확하게 확인해야 합니다. 구매하려는 "상품 등"의 내용과 거래의 조건을 확인하지 않고 구매하여 발생한 모든 손실과 손해는 "회원" 본인에게 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>"회원"은 “살루스케어 계정약관”, “살루스케어 통합서비스 약관” 및 “비타포트 운영정책”과 "회사"가 서비스 화면에서 알리는 내용을 지켜야 하며, 약관과 알리는 내용을 위반하거나 이행하지 않아서 발생하는 모든 손실과 손해는 “회원" 본인에게 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>"회원"은 구매한 "상품 등"에 청약철회의 원인이 발생하면 수령한 "상품 등"을 임의로 사용하거나 훼손되도록 방치해서는 안 됩니다. 청약철회 "상품 등"의 임의사용이나 보관의 미흡으로 "상품 등"이 훼손되었을 때에는 그에 합당한 비용을 부담해야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>"회원"은 "회사"와 "상품 등"의 매매 절차에서 분쟁이 발생하면 분쟁의 해결을 위하여 성실히 임해야 하며, 분쟁 해결 과정에서의 불성실 등 "회원"의 귀책사유로 "회사"에 손실과 손해가 발생하면 그에 대한 모든 책임을 져야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑥</span>
                        <span>"회원"이 상품을 구매할 때는 반드시 본인 명의의 결제수단을 사용해야 하며, 타인의 결제수단을 임의로 사용해서는 안 됩니다. 타인의 결제수단을 임의로 사용하여 발생하는 "회사" 및 결제수단 소유자의 손실과 손해에 대한 모든 책임은 "회원"에게 있습니다.</span>
                    </div>	

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑦</span>
                        <span>매매대금의 결제와 관련하여 "회원"이 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 전적으로 "회원"이 감당해야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number">⑧</span>
                        <span>"회사"는 "회원"이 매매대금 결제 때 사용한 결제수단에 대해 정당한 사용권한이 있는지 확인할 수 있으며, 이에 대한 확인이 완료될 때까지 거래 진행을 중지하거나 해당 거래를 취소할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑨</span>
                        <span>"회사"는 "회원"에게 서비스가 안전하게 제공 될 수 있도록 각종 설비와 자료를 관리해야 하며, 서비스가 제공 목적에 맞게 이용되고 있는지 확인하고 "회원"에게 이용 목적에 위반되는 부분이 있는 것으로 확인되면 사유의 소명을 요청할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑩</span>
                        <span>"회사"가 "회원"의 서비스 이용 편의를 높이기 위해 제휴업체로부터 정보를 제공받아 게재하거나 제3자가 제공하는 방식으로 "쇼핑" 내 또는 링크 방식으로 참조용 정보나 콘텐츠를 제공할 수 있으며, "회원"는 "상품 등"의 구매 때 자신의 판단과 책임으로 결정하여 구매하여야 합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 12 조 (유료 서비스 이용 및 결제 방식)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>살루스케어 통합서비스를 구성하는 개별서비스에는 무료 서비스와 유료 서비스로 구성되며, 유료 서비스 이용 시 회원은 회사가 제공하는 결제 방식을 통해 이용료를 납부해야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>유료 서비스의 결제 방식은 다음과 같습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">1. </span>
                        <span>비타포트(VITAPORT): 일반 상품(건강기능식품, 디지털 상품 등)의 일회성 구매</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">2. </span>
                        <span>헬스케어 여기로(HELLO): 헬스케어 패키지 및 건강 관리 서비스의 패키지 형 결제.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>결제 시 회원은 회사가 지정한 결제수단(신용카드 결제)을 이용할 수 있으며, 각 서비스의 결제 수단 및 방식은 서비스 별 운영정책에 따릅니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 13 조 (유료 서비스의 환불 및 취소 정책)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper pl-32">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>환불 및 취소 정책은 회원이 구매한 서비스에 따라 다음과 같이 적용됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>비타포트(VITAPORT)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>회원은 구매한 상품에 대해 서비스 파트너가 주문확인하기 전까지 구매를 취소할 수 있으며, 배송 중인 경우에는 취소가 아닌 환불절차에 따라 처리됩니다. 배송중인 상품을 취소한 경우 발송된 상품의 왕복 배송비는 “구매자”가 부담합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">II. </span>
                        <span>회원이 상품에 대한 결제를 완료한 후라도 서비스 파트너의 주문확인 이전에 취소신청 접수 시 특별한 사정이 없는 한 즉시 취소처리가 완료됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">III. </span>
                        <span>회원은 전자상거래 등에서의 소비자보호에 관한 법률에 따라, 구매한 상품에 대해 배송 받은 후 7일 이내에 반품 또는 교환을 요청할 수 있으며, 이 경우 회사는 서비스 파트너에게 관련 법령에 의한 환불 등의 절차를 이행하도록 안내합니다. 환불에 관한 일반적인 사항은 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령이 서비스 파트너가 회원에게 제시한 조건보다 우선합니다. 단, 회원이 해당 상품에 대하여 구매확정을 하는 경우에는 회사의 시스템을 통한 환불 신청은 제한될 수 있어 고객센터나 서비스 파트너를 통해 반품 신청하여야 합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">IV. </span>
                        <span>일반적으로 환불에 소요되는 비용은 환불에 대한 귀책사유가 있는 자에게 귀속됩니다. 즉 회원의 단순 변심인 경우는 회원이 반품비용을 부담하며, 상품의 하자로 인한 반품의 경우는 서비스 파트너가 해당비용을 부담합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">V. </span>
                        <span>신용카드를 통한 결제대금 환불 시 결제수단의 전자결제대행사업자, 전자결제대행 또는 중개서비스 사업자의 정책 상 특정기간이 지나 동일한 결제수단의 취소가 불가능한 경우에는 환불정산액으로 환불이 진행됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">VI. </span>
                        <span>회원은 다음 각 호의 경우에는 환불 또는 상품교환을 요청할 수 없습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">1. </span>
                        <span>회원의 귀책사유로 인하여 상품이 멸실·훼손된 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">2. </span>
                        <span> 회원의 상품 사용 또는 소비에 의하여 상품의 가치가 현저히 감소한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">3. </span>
                        <span>시간의 경과에 의하여 재판매가 곤란할 정도로 가치가 현저히 감소한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">4. </span>
                        <span>복제가 가능한 상품의 포장을 훼손한 경우</span>
                    </div>
                    
                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">5. </span>
                        <span>환불 또는 교환을 인정하는 경우 서비스 파트너에게 회복할 수 없는 중대한 피해가 예상되는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">VII. </span>
                        <span>특정기간까지 주문이 정상적으로 종료되지 못할 경우 회사는 거래관계의 확정을 위하여 이용회원의 의사에 명시적으로 반하지 않는 한 해당 주문을 임의로 구매확정 내지 주문 취소 및 환불 처리할 수 있으며, 처리 15일전 관련 내용을 회원에게 통보하여야 합니다. 단, 회원이 이를 원치 않을 경우 이의를 제기할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>배송소요기간은 입금이 확인된 날의 다음 날을 기산일로 하여 배송이 완료되기까지의 기간을 말합니다. 공휴일과 기타 휴무일 또는 천재지변 등 불가항력의 사유가 발생하면 그 해당 기간은 배송 소요 기간에서 제외됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>구매확정기간 내에 회원에게서 교환 또는 반품에 대한 의사표시가 없으면 회사는 해당 거래에 대하여 구매확정의 의사가 있는 것으로 간주하여 다음 날에 자동으로 구매확정 처리(이하 "자동구매확정"이라 합니다)됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>쇼핑 이용과 관련하여 부정행위가 확인되면 회사는 해당 회원에게 부가적으로 제공한 혜택의 일부 또는 전부를 회수하거나, 특정 서비스의 이용을 제한하고, 이용계약을 해지하는 등의 조치를 할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑤</span>
                        <span>타인의 명의, 카드정보, 계좌정보 등을 무단으로 사용하여 회사가 제공하는 서비스를 이용하는 행위는 금지됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑥</span>
                        <span>물품판매 또는 용역제공을 가장하여 자금을 융통하는 것과 같이 여신전문금융업법 등 법령에 따라 금지된 방법으로 비정상적인 결제를 하는 것은 금지되며, 해당 내용이 확인되었을 때 "회사"는 "구매자"의 거래를 취소하거나 중지시키고 관련기관에 통보 할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑦</span>
                        <span>제3자에게 재판매하기 위한 목적으로 회사가 제공하는 혜택이나 할인율 등을 부당하게 이용하는 행위, 회사에 손실을 발생시키는 행위는 금지되며, 재판매 목적의 거래행위가 확인된 경우, 회사는 해당 회원에 대하여 서비스 이용제한, 이용계약의 해지 등의 조치를 취할 수 있으며, 이러한 행위로 손해가 있을 경우 배상을 청구할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑧</span>
                        <span>회사는 회원의 부정거래 행위(현금융통, 결제수단도용, 대량 허위거래 등)가 의심되면 일시적으로 서비스 이용을 정지하고 거래 사실 확인 및 소명을 위해 정지한 날로부터 15일 이내에 필요한 최소한의 증빙자료(거래사실 증명서, 배송 증빙서류 등)를 요청할 수 있습니다. 만약 특별한 사정없이 회사가 요청한 증빙자료를 정해진 기한 내에 제출하지 않거나 서류 미비 또는 소명이 되지 않을 경우 서비스 이용이 영구히 정지되거나 이용계약이 해지 될 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">⑨</span>
                        <span>회사는 회원의 법령 위반, 본 약관 위반, 기타 금지행위 여부에 대한 모니터링을 실시하고 있습니다. 이와 관련하여 회원은 회사의 모니터링 업무에 대하여 협조해야 하며, 회사가 요청하는 최소한으로 필요한 증빙자료를 제출할 의무가 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering two-depth">
                        <span className="number">1. </span>
                        <span>헬스케어 여기로 (HELLO)</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">I. </span>
                        <span>회원은 예약대기 상태에서는 청약 철회 및 시작일 변경이 가능하지만, 예약확정으로 전환될 경우 청약철회 및 시작일 변경이 불가능합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">II. </span>
                        <span>회원은 서비스를 공급받고 서비스 코드를 App.에 입력하는 시점부터 서비스를 사용한 것으로 간주하며 청약철회가 불가능합니다. 또한 서비스를 공급받고 7일내 서비스 코드를 입력하지 않을 경우 7일이 경과되는 시점에 자동 구매확정처리 되어 청약철회가 불가능합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering three-depth">
                        <span className="number">III. </span>
                        <span>회사와 서비스의 이용에 관한 계약을 체결한 회원은 공급받은 날로부터 7일 이내에는 청약의 철회를 할 수 있습니다. 다만, 회사가 다음 각 호 중 하나의 조치를 취한 경우에는 회원의 청약철회권이 제한될 수 있습니다. 또한 구매확정 처리가 되기 전 상품의 배송이 시작된 경우 배송비를 회원에게 청구할 수 있습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">1. </span>
                        <span>회원의 귀책사유로 말미암아 상품이 훼손된 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">2. </span>
                        <span>회원의 사용 또는 일부 소비로 말미암아 상품의 가치가 현저히 감소한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">3. </span>
                        <span>시간이 지나 재 판매가 어려울 정도로 상품의 가치가 현저히 감소한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">4. </span>
                        <span>복제가 가능한 상품의 포장을 훼손한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">5. </span>
                        <span>청약의 철회가 불가능한 “서비스”에 대한 사실을 표시하고 구매회원의 동의를 받은 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">6. </span>
                        <span>한시적 또는 일부이용 등의 방법을 제공한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">7. </span>
                        <span>회원은 다음 각 호의 사유가 있을 때에는 서비스를 공급받은 날로부터 7일 이내에 서비스 하자에 따른 청약철회가 가능하다. 단, 아래 청약철회 요청일에 따라 구분할 수 있다.</span>
                    </div>

                    <div className="contents-new-agree__numbering six-depth">
                        <span className="number">I. </span>
                        <span>이용계약에서 약정한 “서비스”가 제공되지 않는 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering six-depth">
                        <span className="number">II. </span>
                        <span>제공되는 “서비스”의 결과에 오류가 발생한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering six-depth">
                        <span className="number">III. </span>
                        <span>기타 “서비스”의 결함으로 정상적인 이용이 현저히 불가능한 경우</span>
                    </div>

                    <div className="contents-new-agree__numbering six-depth">
                        <span className="number">IV. </span>
                        <span>서비스를 이용하기 위한 배송에 지연이 발생한 경우</span>
                    </div>

                    <div className="horizon-scroll-area service_1">
                        <div className="horizon-scroll">
                            <div className="contents-new-agree__img service_1">
                                <img alt=""/>
                            </div>
                        </div>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">V. </span>
                        <span>헬스케어 여기로 서비스의 경우 일정 기간 이용 후에는 환불이 불가능하며, 비타포트의 경우 상품 배송 완료 후 환불이 제한될 수 있습니다. 세부 환불 규정은 본 조에서 정의하는 내용을 참고해 주시기 바랍니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering five-depth">
                        <span className="number">VI. </span>
                        <span>결제 취소 및 환불 요청은 서비스 내 고객센터 또는 회사가 지정한 절차에 따라 접수해야 합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__maintitle">
                    <span>
                        제 5 장 개인정보 보호 및 데이터
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 14 조 (개인정보 보호 및 활용)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 회원의 개인정보를 보호하기 위해 최선을 다하며, 관련 법령 및 개인정보 처리방침을 따릅니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 회원의 동의 없이 개인정보를 제3자에게 제공하지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">③</span>
                        <span>개별 서비스에서 서비스 제공을 위해 회원의 동의 하에 종합건강검진 결과, 공단검진 결과 정보를 살루스케어 통합서비스 및 제 3자(의료기관, 제휴사 등)에 제공할 수 있으며, 해당 사항은 개인정보처리방침을 통해 상세히 안내됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">④</span>
                        <span>비타포트 서비스는 건강검진 결과 데이터를 바탕으로 운영되며, 헬스케어 여기로 서비스는 실시간 건강 모니터링 데이터(걸음 수, 혈당 등)을 포함할 수 있습니다. 개인정보 삭제 요청 시, 관련 법령에 따라 일정 기간 후 삭제될 수 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 15 조 (서비스 내 데이터 활용 및 보관)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회원이 서비스 이용과정에서 제공한 건강 데이터 및 기타 정보는 개인 맞춤형 서비스를 제공하는데 활용됩니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회사는 서비스 운영을 위해 일정 기간 동안 데이터를 보관하며, 회원이 탈퇴하거나 요청하는 경우 관련 법령에 따라 데이터를 삭제할 수 있습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__maintitle">
                    <span>
                        제 6 장 책임 및 면책 조항
                    </span>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 16 조 (손해배상 및 면책)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사는 통합서비스 운영과 관련하여 고의 또는 중대한 과실이 없는 경우 손해배상의 책임을 지지 않습니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회원의 귀책사유로 인해 발생한 문제에 대해서는 회사가 책임을 지지 않습니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 17 조 (서비스 공지 및 통지)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>서비스 회원 전체에 대한 공지는 7일 이상 서비스 공지사항에 게시함으로써 효력이 발생합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>회원에게 중대한 영향을 미치는 사항은 이메일, 문자, 서비스 내 알림 등을 통해 개별적으로 통지합니다.</span>
                    </div>
                </div>

                <div className="contents-new-agree__subtitle">
                    <span>
                        제 18 조 (분쟁 해결)
                    </span>
                </div>

                <div className="contents-new-agree__numbering-wrapper">
                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">①</span>
                        <span>회사와 회원 간 발생한 분쟁은 성실히 협의하여 해결합니다.</span>
                    </div>

                    <div className="contents-new-agree__numbering">
                        <span className="number_ring">②</span>
                        <span>협의가 이루어지지 않는 경우, 대한민국 법령에 따라 관할법원에서 해결합니다.</span>
                    </div>
                </div>
            </LayoutPolicy>
        </div>
    )
}

export default SalusTermPage;
